import { DEFAULT_SITE_NAME } from "@/lib/siteIdentity";
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import Logo from "@/components/Logo";
import ThemeToggle from "@/components/ThemeToggle";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();
    const settings = useSiteSettings();

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await login(email.trim(), password);
        setLoading(false);
        if (res.ok) {
            if (res.user?.must_change_password) {
                toast.info("يجب تعيين كلمة مرور جديدة قبل الدخول إلى لوحة التحكم");
                navigate("/force-change-password");
            } else {
                toast.success("تم تسجيل الدخول");
                navigate("/admin");
            }
        } else toast.error(res.error);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4 public-scope ui-surface relative">
            <div className="absolute top-4 end-4 z-10" dir="ltr"><ThemeToggle /></div>
            <div className="w-full max-w-md bg-white rounded-sm border border-gray-200 shadow-sm p-8">
                <Link to="/" className="flex items-center justify-center gap-3 mb-6">
                    <Logo logoUrl={settings.logo_url} size="h-12 w-12" textSize="text-base" />
                    <div className="font-display font-black text-xl">{settings.site_name || DEFAULT_SITE_NAME.ar}</div>
                </Link>
                <h1 className="font-display font-black text-2xl mb-1 text-brand-black">تسجيل دخول المحرر</h1>
                <p className="text-sm text-gray-500 mb-6">أدخل بيانات حسابك للوصول إلى لوحة التحكم.</p>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <Label className="mb-1 block">اسم المستخدم</Label>
                        <Input type="text" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-sm" data-testid="login-email" />
                    </div>
                    <div>
                        <Label className="mb-1 block">كلمة المرور</Label>
                        <Input type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-sm" data-testid="login-password" />
                    </div>
                    <Button type="submit" disabled={loading} className="w-full bg-brand-red hover:bg-brand-red-dark rounded-sm" data-testid="login-submit">
                        <LogIn className="w-4 h-4" /> {loading ? "جارٍ الدخول..." : "دخول"}
                    </Button>
                </form>
                <Link to="/" className="mt-6 block text-center text-sm text-gray-500 hover:text-brand-red">العودة إلى الموقع</Link>
            </div>
        </div>
    );
}
